/**
 * La espera entre reintentos de conexión.
 *
 * **El desorden aleatorio no es un adorno.** Cuando se corta el punto de acceso del aula, los
 * cuarenta móviles pierden la conexión en el mismo milisegundo; sin él, los cuarenta reintentarían
 * a la vez, en tandas sincronizadas, y el servidor recibiría cuarenta saludos simultáneos cada vez.
 * Repartirlos convierte una avalancha en un goteo.
 */

/** Primer reintento casi inmediato: la mayoría de los cortes duran menos de un segundo. */
export const BACKOFF_BASE_MS = 500;
/** Techo: más allá, la persona ya ha decidido recargar. */
export const BACKOFF_MAX_MS = 15_000;
/** Cuánto se dispersa, en tanto por uno. */
export const BACKOFF_JITTER = 0.25;

export function backoffDelay(attempt: number, random: () => number = Math.random): number {
  const exponential = Math.min(BACKOFF_BASE_MS * 2 ** Math.max(0, attempt), BACKOFF_MAX_MS);
  const spread = exponential * BACKOFF_JITTER;
  return Math.round(exponential - spread + random() * spread * 2);
}
